import React from "react";

const NOISE_COLOR = { normal: "rgba(255,59,0,0.5)", danger: "#FF3B00" };
const BLUR_COLOR  = { normal: "rgba(57,255,20,0.4)", danger: "#39FF14" };

const Meter = ({ label, value, color, dangerAt = 0.66, testid }) => {
    const pct = Math.round(Math.max(0, Math.min(1, value)) * 100);
    const danger = value >= dangerAt;

    return (
        <div className="flex flex-col items-center gap-2" data-testid={testid}>
            <div className="relative h-32 w-4 bg-black border border-white/10 overflow-hidden">
                <div
                    className="meter-fill absolute bottom-0 left-0 right-0"
                    style={{
                        height: `${pct}%`,
                        background: danger ? color.danger : color.normal,
                        boxShadow: danger ? `0 0 12px ${color.danger}` : "none",
                    }}
                    aria-hidden="true"
                />
                {/* tick marks */}
                {[0.25, 0.5, 0.75].map((t) => (
                    <div
                        key={t}
                        className="absolute left-0 right-0 h-px bg-white/15"
                        style={{ bottom: `${t * 100}%` }}
                    />
                ))}
            </div>
            <div
                className="text-[9px] tracking-[0.2em] uppercase text-amber font-mono"
                aria-label={`${label} meter: ${pct} percent`}
            >
                {label}
            </div>
            <div className="text-[10px] tabular-nums text-[var(--text-secondary)]">{pct}%</div>
        </div>
    );
};

export const Meters = ({ noise, blur }) => (
    <div className="flex items-end gap-6 justify-around w-full" data-testid="meters-panel">
        <Meter
            label="Noise"
            value={noise}
            color={NOISE_COLOR}
            testid="meter-noise"
        />
        <Meter
            label="Blur"
            value={blur}
            color={BLUR_COLOR}
            testid="meter-blur"
        />
    </div>
);

export default Meters;
